'use client'

import { cn } from '@/lib/utils'
import * as SliderPrimitive from '@radix-ui/react-slider'
import { formatToBRL } from 'brazilian-values'
import * as React from 'react'

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>>(
	({ className, min = 30, max = 5000, value, defaultValue, ...props }, ref) => {
		const percentage = React.useMemo(() => {
			const currentValue = value?.[0] ?? defaultValue?.[0] ?? min
			const calculatedPercentage = ((currentValue - min) / (max - min)) * 100
			return Math.min(Math.max(calculatedPercentage, 0), 100)
		}, [value, defaultValue, min, max])

		return (
			<div className="relative mt-8  flex flex-col self-center px-8">
				<div
					className="absolute text-sm text-white bg-light_purple px-2 py-1 rounded whitespace-nowrap"
					style={{
						left: `calc(${Math.min(Math.max(percentage, 2), 98)}%)`,
						transform: 'translateX(-50%)',
						top: '-2rem',
					}}
				>
					{formatToBRL(value?.[0] ?? defaultValue?.[0] ?? min)}
				</div>
				<SliderPrimitive.Root
					ref={ref}
					className={cn('relative flex w-full touch-none select-none items-center', className)}
					min={min}
					max={max}
					value={value}
					defaultValue={defaultValue}
					{...props}
				>
					<SliderPrimitive.Track className="relative h-4 w-full grow overflow-hidden rounded-full bg-gray-200">
						<SliderPrimitive.Range className="absolute h-full bg-light_purple" />
					</SliderPrimitive.Track>
					<SliderPrimitive.Thumb className="block h-8 w-8 rounded-full border-4 border-[#ffffff] bg-light_purple transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50" />
				</SliderPrimitive.Root>
				<div className="flex justify-between mt-2 text-sm text-gray-600">
					<span>Mínimo ({formatToBRL(min)})</span>
					<span>Máximo ({formatToBRL(max)})</span>
				</div>
			</div>
		)
	},
)

export { Slider }
